module.exports = function (property) {
  let civicNumber =
    property.property.civic_number_start +
    (property.property.civic_number_end
      ? "-" + property.property.civic_number_end
      : "");
  return `${civicNumber} ${property.property.street_name}`;
};
